export default "__VITE_ASSET__CelZZZqq__"